// index.tsx
// (c) NCR Voyix Corporation 2025. All rights reserved.

import { Stack, Typography } from '@mui/material'
import React from 'react'
import AlohaLogo from '../../../../logos/AlohaLogo304x83.png'

export function TopLoginLogo(): JSX.Element {
  return (

    <Stack
      sx={{
        alignItems: 'center'
      }}
    >
      <img
        data-testid="Aloha_logo"
        src={AlohaLogo}
        alt="AlohaUpgrades"
      />
      <Typography
        sx={{
          color: '#5F259F',
          fontWeight: 'bold',
          marginTop: 2,
          marginBottom: 2,
          fontSize: 25
        }}
      >
        Solution Upgrades
      </Typography>
    </Stack>
  )
}
